export * from "./base-component";

export * from "./base-component-transformer";
//# sourceMappingURL=index.js.map
